import { render } from "./TechEventsPage.vue?vue&type=template&id=6d87420b&scoped=true"
import script from "./TechEventsPage.vue?vue&type=script&lang=js"
export * from "./TechEventsPage.vue?vue&type=script&lang=js"

import "./TechEventsPage.vue?vue&type=style&index=0&id=6d87420b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d87420b"]])

export default __exports__